import { useRef, type PointerEvent } from 'react'

const CLOSE_DISTANCE_PX = 80

/**
 * Смахивание шторки вниз за её шапку. Шторка едет за пальцем; отпустили дальше порога — закрываем,
 * иначе возвращается на место. Только вниз: вверх шторке расти некуда.
 */
export const useSheetSwipe = (onClose: () => void) => {
  const sheetRef = useRef<HTMLDivElement>(null)
  const start = useRef<number | null>(null)

  const move = (offset: number) => {
    const sheet = sheetRef.current
    if (sheet) sheet.style.transform = offset > 0 ? `translateY(${offset}px)` : ''
  }

  const finish = (e: PointerEvent, canClose: boolean) => {
    if (start.current === null) return
    const offset = e.clientY - start.current
    start.current = null
    move(0)
    if (canClose && offset > CLOSE_DISTANCE_PX) onClose()
  }

  const handlers = {
    onPointerDown: (e: PointerEvent<HTMLElement>) => {
      // Кнопка в шапке (крестик) остаётся кнопкой.
      if ((e.target as HTMLElement).closest('button')) return
      start.current = e.clientY
      e.currentTarget.setPointerCapture?.(e.pointerId)
    },
    onPointerMove: (e: PointerEvent) => {
      if (start.current !== null) move(e.clientY - start.current)
    },
    onPointerUp: (e: PointerEvent) => finish(e, true),
    onPointerCancel: (e: PointerEvent) => finish(e, false),
  }

  return { sheetRef, handlers }
}
